/**
 * Inline error card — rendered inside the chat stream so the
 * max-iterations / network / agent error appears as a
 * system-error message rather than as a free-floating bar
 * wedged between the last message and the composer (#1480).
 *
 * Pure presentational leaf: derives the transient/upgrade-required
 * presentation from the provided error and wires the supplied callbacks.
 * Returns null for upgrade-required errors (handled elsewhere).
 */
export function ChatInlineError({
  error,
  onRetry,
  onReport,
}: {
  error: Error;
  onRetry: () => void;
  onReport: (error: Error) => void;
}) {
  const errMsg = (error.message || '').toLowerCase()
  const isTransient = /network|timeout|502|503|504|fetch failed|econnrefused|unavailable|took too long|connection lost/.test(errMsg)
  const upgradeRequired = (error as Error & { upgradeRequired?: boolean }).upgradeRequired
  if (upgradeRequired) return null
  return (
    <div className="chat-message-row assistant">
      <div className="chat-error chat-error-inline">
        <span>⚠️ {error.message}</span>
        {isTransient && (
          <button
            className="chat-error-retry-btn"
            onClick={onRetry}
          >
            Retry
          </button>
        )}
        <button
          className="chat-error-report-btn"
          onClick={() => onReport(error)}
        >
          Report
        </button>
      </div>
    </div>
  )
}
